import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInterpolate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 49.17,
			d: "M11013.3 173.56c57.6 18.929 93.5 45.662 93.5 75.273 0 57.329-134.7 103.872-300.6 103.872-165.8 0-300.5-46.543-300.5-103.872 0-29.611 35.9-56.344 93.5-75.273 37.8 26.309 116.4 44.409 207 44.409 90.7 0 169.3-18.1 207.1-44.409",
			transform: "matrix(1.43963 0 0 1.48836 -15045 237.547)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 63.98,
			d: "M11001.8 169.969c64.3 19.056 105 47.328 105 78.864 0 57.329-134.7 103.872-300.6 103.872-165.8 0-300.5-46.543-300.5-103.872 0-31.536 40.7-59.808 105-78.864 40.5 22.654 112.9 37.766 195.5 37.766 82.7 0 155.1-15.112 195.6-37.766",
			transform: "matrix(1.10643 0 0 1.14388 -11444.3 158.511)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 10806.2,
			cy: 248.833,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 83.77,
			rx: 300.563,
			ry: 103.873,
			transform: "matrix(.84511 0 0 .87372 -8620.52 87.967)"
		})
	]
});
export default SvgIconInterpolate;
